module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa robocza",
      "error": _vm.errors['working_name'],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form['working_name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'working_name', $$v)
      },
      expression: "form['working_name']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slides"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.slides), function(slide, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (slide.title_pl || 'Nowy slajd')),
        "errors": _vm.checkForErrors(_vm.errors.slides, [i]),
        "items": _vm.form.slides,
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "slides", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj grafikę na całym slajdzie",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['media_on_whole_slide']
      }
    }, [_c('el-switch', {
      model: {
        value: (slide['media_on_whole_slide']),
        callback: function($$v) {
          _vm.$set(slide, 'media_on_whole_slide', $$v)
        },
        expression: "slide['media_on_whole_slide']"
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": slide['media_on_whole_slide']
      },
      model: {
        value: (slide[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "slide[addLanguageSuffix('title')]"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.bg_color),
        callback: function($$v) {
          _vm.$set(slide, "bg_color", $$v)
        },
        expression: "slide.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (slide.text_color),
        callback: function($$v) {
          _vm.$set(slide, "text_color", $$v)
        },
        expression: "slide.text_color"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Podtytuł",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i][_vm.addLanguageSuffix('subtitle')]
      }
    }, [_c('wyswig-input', {
      attrs: {
        "simple": true
      },
      model: {
        value: (slide[_vm.addLanguageSuffix('subtitle')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('subtitle'), $$v)
        },
        expression: "slide[addLanguageSuffix('subtitle')]"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "źródło iframe (domyślnie na całym slajdzie)",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i].iframe
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "https://player.vimeo.com/video/278003111?autoplay=1&muted=1"
      },
      model: {
        value: (slide.iframe),
        callback: function($$v) {
          _vm.$set(slide, "iframe", $$v)
        },
        expression: "slide.iframe"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Grafika",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (slide.image),
        callback: function($$v) {
          _vm.$set(slide, "image", $$v)
        },
        expression: "slide.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "URL do filmu",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['video']
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "https://www.youtube.com/watch?v=blJKoXWlqJk"
      },
      model: {
        value: (slide['video']),
        callback: function($$v) {
          _vm.$set(slide, 'video', $$v)
        },
        expression: "slide['video']"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!slide['media_on_whole_slide']),
        expression: "!slide['media_on_whole_slide']"
      }],
      attrs: {
        "label": "Przycisk"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Ukryj przycisk"
      }
    }, [_c('el-switch', {
      attrs: {
        "disabled": slide.media_on_whole_slide
      },
      model: {
        value: (slide.hide_button),
        callback: function($$v) {
          _vm.$set(slide, "hide_button", $$v)
        },
        expression: "slide.hide_button"
      }
    })], 1), _vm._v(" "), (!slide.hide_button) ? _c('el-form-item', {
      attrs: {
        "label": "Nazwa",
        "error": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['button_title']
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": slide.hide_button
      },
      model: {
        value: (slide[_vm.addLanguageSuffix('button_title')]),
        callback: function($$v) {
          _vm.$set(slide, _vm.addLanguageSuffix('button_title'), $$v)
        },
        expression: "slide[addLanguageSuffix('button_title')]"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!slide.hide_button) ? _c('link-component', {
      attrs: {
        "errors": _vm.errors.slides && _vm.errors.slides[i] && _vm.errors.slides[i]['button_link']
      },
      model: {
        value: (slide.button_link),
        callback: function($$v) {
          _vm.$set(slide, "button_link", $$v)
        },
        expression: "slide.button_link"
      }
    }) : _vm._e()], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSlide
    }
  }, [_vm._v("\n                            Dodaj slajd\n                        ")])], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b05517d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Popups/PopupForm.vue
// module id = 793
// module chunks = 0